import { SellingCompanyReport } from '../../../tms-shared';

export interface StockItemLabel {
  stockNo: string;
  productKey: string;
  productOldCode: string;
  productDescription: string;
  batchNo: string;
  grossQuantity: number;
  nettQuantity: number;
  tare: number;
  grossQuantityImperial: number;
  nettQuantityImperial: number;
  tareImperial: number;
  unitOfMeasure: string;

  sellingCompany: SellingCompanyReport;
}
